let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("h2YqG")]).then(() => parcelRequire('7gC33'));